import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const filterC3ExportsSchema = z.object({
  client_contains: z.string().optional(),
  user_contains: z.string().optional(),
  created_at_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  created_at_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_from: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  report_date_to: z
    .preprocess((val) => parseToDateValue(val), dateSchema)
    .optional(),
  file_name_contains: z.string().optional(),
  status_contains: z.string().optional(),
});

export type FilterC3ExportsSchemaType = z.infer<typeof filterC3ExportsSchema>;

export function FilterC3Exports() {
  const { t } = useTranslation();
  const fields = useMemo<Field[]>(
    () => [
      {
        name: "client_contains",
        label: "Client",
        type: "input",
      },
      {
        name: "user_contains",
        label: t("download_center.columns.user_name", {
          defaultValue: "Utilisateur",
        }),
        type: "input",
      },
      {
        name: "file_name_contains",
        label: t("download_center.columns.file_name", {
          defaultValue: "Nom du fichier",
        }),
        type: "input",
      },
      {
        name: "status_contains",
        label: t("download_center.columns.status", { defaultValue: "Statut" }),
        type: "input",
      },
      {
        name: "created_at",
        type: "dateRange",
        label: t("download_center.columns.created_at", {
          defaultValue: "Date de génération",
        }),
        from: { name: "created_at_from" },
        to: { name: "created_at_to" },
      },
      {
        name: "report_date",
        type: "dateRange",
        label: t("download_center.columns.reporting_date", {
          defaultValue: "Date du rapport",
        }),
        from: { name: "report_date_from" },
        to: { name: "report_date_to" },
      },
    ],
    [t],
  );
  return (
    <FilterTable
      schema={filterC3ExportsSchema}
      client="c3"
      tableName="c3_exports"
      fields={fields}
    />
  );
}
